import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "store/store";

const RootRedirect = () => {
  const navigate = useNavigate();
  const { current } = useAppSelector((state) => state.language);

  useEffect(() => {
    // Ensure current has a valid value, default to 'en' if not set
    const lang = current || "en";
    navigate(`/${lang}`, { replace: true });
  }, [current, navigate]);

  return null;
};

export default RootRedirect;